// extracted by mini-css-extract-plugin
export default {"logo":"siderMenu_logo__O5+4Z","groupLabel":"siderMenu_groupLabel__1sVYw","groupTitle":"siderMenu_groupTitle__vEbwo"};